import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../components/AppProvider";

// Utils

import dayjs from "dayjs";
import styled from "styled-components";
import { PostApi1704 } from "../../../modules/network/padoPost";
import { scrollUnLock } from "../../../modules/utils/ScrollLock";
import { closeLayerFn } from "../../Layout";
import TreatmentDataCalendar from "./TreatmentDataCalendar";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [isDisplay, setIsDisplay] = useState(false);
  const [isCalDisplay, setIsCalDisplay] = useState(false);
  const [checkedDate, setCheckedDate] = useState([]);
  const [selectDate, setSelectDate] = useState("");
  const [rawSelectDate, setRawSelectDate] = useState("");
  const [hsptNm, setHsptNm] = useState("");
  const [studNm, setStudNm] = useState("");
  const [loading, setLoading] = useState(true);
  const { loadDataList, loadHospitalList } = props;

  const onCloseHandler = async () => {
    closeLayerFn($("#addTrtmtData"));
    setIsCalDisplay(false);
    scrollUnLock();

    setHsptNm("");
    setStudNm("");
    $("input[name=hsptNm]").val("");
    $("input[name=studNm]").val("");
    defaultDateSet();
    // setSelectDate(getDateFormat(rawSelectDate));
  };

  const onSetHandler = async () => {
    if (hsptNm == "") {
    } else if (studNm == "") {
    } else {
      SaveData(rawSelectDate.replace(/-/gi, ""), hsptNm, studNm);
      scrollUnLock();

      setHsptNm("");
      setStudNm("");
      $("input[name=hsptNm]").val("");
      $("input[name=studNm]").val("");
      defaultDateSet();
    }
  };

  const onCalendarOpenHandler = () => {
    setIsCalDisplay(true);
    setLoading(true);
  };

  const week = new Array(
    " (일)",
    " (월)",
    " (화)",
    " (수)",
    " (목)",
    " (금)",
    " (토)"
  );
  const getDateFormat = dateStr => {
    let dotw = new Date(dateStr).getDay(); // ==> "yyyy-MM-dd"
    let date = new Date(dateStr);
    let cnvtDate = dayjs(date).format("YYYY.MM.DD");
    return cnvtDate + week[dotw];
  };

  const SaveData = (studDt, hsptNm, studNm) => {
    PostApi1704(
      userinfo,
      cfg,
      phonecfg,
      "I",
      "",
      studDt,
      hsptNm,
      studNm,
      "U",
      ""
    )
      .then(res => {
        if ((res.resultCode = "E000")) {
          setIsCalDisplay(false);
          loadDataList();
          loadHospitalList();
          closeLayerFn($("#addTrtmtData"));
          scrollUnLock();
        }
      })
      .catch(err => {
        console.log("SERVER ERR :: ", err);
      });
  };

  const defaultDateSet = () => {
    let date = new Date();
    let cnvtDate = dayjs(date).format("YYYY-MM-DD");
    setRawSelectDate(cnvtDate);
  };

  useEffect(() => {
    defaultDateSet();
  }, []);

  useEffect(() => {
    setSelectDate(getDateFormat(rawSelectDate));
  }, [rawSelectDate]);

  return (
    <div
      className="blacklayer-container"
      id={"addTrtmtData"}
      style={{ display: "none" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical priv">
          <div className="blgr-title" style={{ textAlign: "left" }}>
            진료추가
          </div>
          <div
            className="inp-with-unit"
            style={{ paddingBottom: "10px", paddingTop: "10px" }}
            onClick={() => onCalendarOpenHandler()}>
            <input
              type="text"
              className="textbox datetime-picker-input pick-result"
              style={{ height: "46px", lineHeight: "46px", fontSize: "0.9rem" }}
              maxLength={30}
              readOnly={true}
              defaultValue={selectDate}
            />
          </div>
          {/* { isCalDisplay && ( */}
          <div style={{ display: isCalDisplay ? "block" : "none" }}>
            <TreatmentDataCalendar
              loading={loading}
              setLoading={setLoading}
              rawSelectDate={rawSelectDate}
              setRawSelectDate={setRawSelectDate}
              setSelectDate={setSelectDate}
              checkedDate={checkedDate ? checkedDate : []}
              setIsCalDisplay={setIsCalDisplay}
            />
          </div>
          {/* )} */}
          <div
            className="inp-with-unit"
            style={{ paddingBottom: "10px", paddingTop: "10px" }}>
            <InputTextForm
              type="text"
              name="hsptNm"
              placeholder="병원을 입력하세요"
              maxLength={30}
              onBlur={e => {
                setHsptNm(e.target.value);
              }}
            />
          </div>
          <div
            className="inp-with-unit"
            style={{ paddingBottom: "10px", paddingTop: "10px" }}>
            <InputTextForm
              type="text"
              name="studNm"
              placeholder="진료명"
              maxLength={30}
              onBlur={e => {
                setStudNm(e.target.value);
              }}
            />
          </div>
          <div className="tbns-area">
            <a className="btn-round gray" onClick={() => onCloseHandler()}>
              취소
            </a>
            <a className="btn-round wht" onClick={() => onSetHandler()}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

/* css */
const InputTextForm = styled.input`
  padding: 0px 60px 0px 15px;
  width: 100%;
  height: 46px;
  line-height: 46px;
  font-size: 0.9rem;
  box-sizing: border-box;
  color: #000;
  border: 1px solid #e0e0e0;
  border-radius: 7px !important;
  background: #fff;
`;
